import React, { Component } from 'react';
import { connect } from 'react-redux';

import { withRouter, Redirect } from 'react-router-dom';

import { currentUserRole } from '../util';

class RequireAuth extends Component{

  render(){
    const {
      authenticated,
      authenticating,
      organization,
    } = this.props;

    // console.log('authenticated check in requireAuth...');
    // console.log(authenticated);
    // console.log('user is authenticating: ', this.props.authenticating);
    // console.log('user: ', this.props.user);
    //
    // console.log('current location: ', this.props.location);

    if(!authenticating && !authenticated){
      return (
        <Redirect to={{
            pathname: '/login',
            state: { referrer: this.props.location.pathname }
          }} />
      )
    }
    else if(authenticating){
      return (
        <div className="page loading">
          <h1>Authenticating...</h1>
        </div>
      );
    }
    // else if(!organization){
    //   return (
    //     <div className="page loading">
    //       <h1>Loading Organization Data...</h1>
    //     </div>
    //   );
    // }
    else{
      return this.props.children;
    }
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    authenticating: state.user === 'authenticating',
    authenticated: (state.user && state.user.uid) ? true : false,
    organization: state.organization.data,
  }
}

export default connect(mapStateToProps, {})(RequireAuth);



// WEBPACK FOOTER //
// ./src/routes/requireAuth.js